import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { visitorId, utm } from "@/lib/track";

export const SimilarRequest = ({ v, className = "", suffix = "" }) => {
  const { t, lang, tErr } = useLang();
  const [busy, setBusy] = useState(false);
  const go = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setBusy(true);
    const w = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ? null : window.open("", "_blank");
    try {
      const { data } = await api.post("/public/inquiries", { type: "similar", vehicle_id: v.id, visitor_id: visitorId(), lang, utm: utm() });
      if (w) w.location.href = data.whatsapp_url; else window.location.href = data.whatsapp_url;
    } catch (err) {
      w?.close();
      toast.error(tErr(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className={`space-y-2.5 ${className}`} data-testid={`similar-section-${v.code}${suffix}`}>
      <p className="text-sm font-medium text-white flex items-center gap-2"><span className="h-px w-5 bg-[var(--xd-red)]" />{t("similar.title")}</p>
      <p className="text-xs text-zinc-400 leading-relaxed">{t("similar.text")}</p>
      <button type="button" onClick={go} disabled={busy} data-testid={`similar-whatsapp-button-${v.code}${suffix}`}
        className="btn-ghost w-full !min-h-[2.75rem] !text-sm !border-white/30 hover:!border-white/60 !bg-white/[0.03] whitespace-nowrap">
        <MessageCircle size={16} className="shrink-0 text-emerald-400" />{t("similar.button")}
      </button>
    </div>
  );
};
